'use client';
// When a screen's back-online re-read may run (BUG-2111): after the reconnect's change queue upload
// pass, which OfflineSyncProvider reports here. Its own context, apart from the sync state, so a
// screen re-renders on a replay, never on each sync progress tick.
import { createContext, useContext } from 'react';

/** What a screen's back-online re-read waits on. */
export interface BackOnlineReplayValue {
  /** True while the sync engine runs, so a reconnect sends the change queue before anything re-reads. */
  available: boolean;
  /** Counts the reconnects whose upload pass has finished; it moves only after the edge. */
  replays: number;
  /**
   * Counts the upload passes that sent a queued change, whenever they ran (BUG-2678). A screen mounted
   * after the way back online, which saw no edge, re-reads when it moves.
   */
  writesSent: number;
}

/** Outside the native app (or before its store opens) there is no queue to wait for. */
export const BackOnlineReplayContext = createContext<BackOnlineReplayValue>({
  available: false,
  replays: 0,
  writesSent: 0,
});

/**
 * @returns whether a reconnect replays the change queue, how many reconnect replays have finished, and how many
 * upload passes have sent a change.
 */
export function useBackOnlineReplay(): BackOnlineReplayValue {
  return useContext(BackOnlineReplayContext);
}
